var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(-0.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    transform: "translate(0.305)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1778",
    "data-name": "Rectangle 1778",
    width: 9,
    height: 9,
    transform: "translate(0.305)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(1.081 0.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M4,6V7.081H6.163v4.867H7.244V7.081H9.407V6Z",
    transform: "translate(-4 -4.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M25.622,2.541V2H24v.541h.541V9.03H24V9.57h1.622V9.03h-.541V2.541Z",
    transform: "translate(-18.593 -2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLabel);
export default __webpack_public_path__ + "static/media/edit-label.38ae322e.svg";
export { ForwardRef as ReactComponent };